import { useContext, useEffect, useRef } from "react";
import { MessagesContext } from "contexts/messagesContext";

// Feeds LIVECHAT_EVENT socket messages to onEvent once each, and calls onReconnect once per reconnect.
export const useLivechatRealtime = (onEvent, onReconnect) => {
  const { livechatValue } = useContext(MessagesContext);
  const [events = [], connects = 0] = livechatValue ?? [];
  const lastSeqRef = useRef(null);
  const connectsRef = useRef(connects);
  const handlersRef = useRef({ onEvent, onReconnect });
  handlersRef.current = { onEvent, onReconnect };

  useEffect(() => {
    const latestSeq = events.length ? events[events.length - 1].seq : 0;

    // events from before this page opened are already in its first fetch
    if (lastSeqRef.current === null) {
      lastSeqRef.current = latestSeq;
      return;
    }

    const fresh = events.filter((event) => event.seq > lastSeqRef.current);
    lastSeqRef.current = Math.max(lastSeqRef.current, latestSeq);
    fresh.forEach((event) => handlersRef.current.onEvent(event));
  }, [events]);

  useEffect(() => {
    if (connects > connectsRef.current) {
      const wasConnected = connectsRef.current > 0;
      connectsRef.current = connects;
      if (wasConnected) handlersRef.current.onReconnect();
    }
  }, [connects]);
};
